module.exports = __webpack_public_path__ + "c49b3981651dfe7f281418762ba6ead9.eot";